import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const monarchtrackingConfig: TSPConfig = {
  key: 'monarchtracking',
  name: 'Monarch Tracking',
  imageName: 'MonarchTracking',
  category: TSPCategory.CUSTOM,
  helpText:
    'Input the credentials you use to access Monarch Tracking. Request an API Key from Monarch Tracking support if you do not have one.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'API Token',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default monarchtrackingConfig;
